import {Inject, Injectable, InjectionToken} from '@angular/core';
import {StorageService} from 'ngx-webstorage-service';

export const TOKEN_SERVICE_STORAGE =
    new InjectionToken<StorageService>('TOKEN_SERVICE_STORAGE');

const STORAGE_KEY = 'app_token';

@Injectable()
export class TokenStorageService {

    constructor(@Inject(TOKEN_SERVICE_STORAGE) private storage: StorageService) {

    }

    get(): string | null {
        return this.storage.get(STORAGE_KEY);
    }

    has(): boolean {
        return this.storage.has(STORAGE_KEY);
    }

    set(token: string): void {
        return this.storage.set(STORAGE_KEY, token);
    }

    empty() {
        this.storage.remove(STORAGE_KEY);
    }
}
